import { ANNOTATIONS } from '../actions/AnnotationsActions'

function initialState() {
  return null
}

export default function annotations(state = initialState(), action) {
  switch (action.type) {
    case ANNOTATIONS:
      return action.payload
    default:
      return state
  }
}
